var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('kaihu-list',{attrs:{"title":"商家开户","route":_vm.route,"config":['cmb']}})}
var staticRenderFns = []

export { render, staticRenderFns }